export function useCustomScrollbar() {
  let cleanup = null;

  const initialize = (containerRef, contentRef, thumb, scroller) => {
    const container = containerRef.value;
    const content = contentRef.value;

    if (!container || !content || !thumb || !scroller) {
      console.warn(
        "One or more refs are not initialized, cannot initialize scrollbar:",
        {
          container: !!container,
          content: !!content,
          thumb: !!thumb,
          scroller: !!scroller,
        }
      );
      return;
    }

    const updateContainerHeight = () => {
      scroller.style.display = "none";
      content.classList.add("not-overflow");
      void scroller.offsetHeight;
      scroller.style.display =
        content.scrollHeight > content.clientHeight ? "block" : "none";

      content.scrollHeight > content.clientHeight
        ? content.classList.remove("not-overflow")
        : content.classList.add("not-overflow");
    };

    const updateThumbPosition = () => {
      const containerHeight = content.clientHeight;
      const contentHeight = content.scrollHeight;
      const scrollTop = content.scrollTop;

      const thumbHeight = Math.max(
        (containerHeight / contentHeight) * containerHeight,
        30
      );
      const thumbTop = (scrollTop / contentHeight) * containerHeight;

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.top = `${thumbTop}px`;
    };

    let isDragging = false;
    let startY, startTop;

    const handleMouseDown = (e) => {
      isDragging = true;
      startY = e.clientY;
      startTop = parseInt(window.getComputedStyle(thumb).top, 10);
      document.body.style.userSelect = "none";
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;

      const deltaY = e.clientY - startY;
      const newTop = Math.max(
        0,
        Math.min(scroller.offsetHeight - thumb.offsetHeight, startTop + deltaY)
      );
      const scrollRatio = content.scrollHeight / content.clientHeight;
      content.scrollTop = newTop * scrollRatio;
      thumb.style.top = `${newTop}px`;
    };

    const handleMouseUp = () => {
      if (isDragging) {
        isDragging = false;
        document.body.style.userSelect = "";
      }
    };

    thumb.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("resize", updateContainerHeight);
    content.addEventListener("scroll", updateThumbPosition);

    setTimeout(() => {
      updateContainerHeight();
      updateThumbPosition();
    }, 100);

    cleanup = () => {
      thumb.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("resize", updateContainerHeight);
      content.removeEventListener("scroll", updateThumbPosition);
    };
  };

  const destroy = () => {
    if (cleanup) {
      cleanup();
      cleanup = null;
    }
  };

  return { initialize, destroy };
}
